module.exports = __webpack_public_path__ + "static/media/f_hairstyle_tightcurls_medium_back_vector.27092525.svg";